import { prop } from 'ramda';

import { clear, unprefix } from '../../../../helpers/compact';
import { MEDIA_TYPE } from '../../../../types/press-media';
import { CommonSliceType } from '../../../../types/slice';
import { toSize } from '../../mapping/size';
import { quote } from '../../partials/quote';
import { video } from '../../partials/video';

export const videoSlice = ({ primary }) => {
  const normalizedVideo = video(primary);

  if (normalizedVideo) {
    return clear({
      type: CommonSliceType.VIDEO_N_CAPTION,
      size: toSize(prop('video_player_size', primary)),
      ...normalizedVideo,
    });
  }
};

export const videoWithQuoteSlice = ({ primary }) => {
  const normalizedVideo = video(primary);
  const normalizedQuote = quote(unprefix('video', primary));

  if (normalizedVideo && normalizedQuote) {
    const { position, ...normalizedQuoteRest } = normalizedQuote;
    return clear({
      type: CommonSliceType.VIDEO_N_QUOTE,
      media: normalizedVideo,
      mediaType: MEDIA_TYPE.VIDEO,
      quote: normalizedQuoteRest,
      position,
    });
  }
};

export const videoWithTextSlice = ({ primary }) => {
  const normalizedVideo = video(primary);

  if (normalizedVideo) {
    return clear({
      type: CommonSliceType.VIDEO_N_TXT,
      media: normalizedVideo,
      mediaType: MEDIA_TYPE.VIDEO,
      text: prop('txt', primary),
    });
  }
};
